/**
 * `equipmentRequest` translations, for every locale: asking on My equipment and answering on Inventory.
 */
export const equipmentRequests = {
  mn: {
    equipmentRequest: {
      request: 'Хүсэлт',
      requestHint: 'Шинэ эсвэл солих тоног төхөөрөмж хүсэх',
      title: 'Тоног төхөөрөмж хүсэх',
      kindLabel: 'Төрөл',
      kind: {
        laptop: 'Компьютер',
        office: 'Оффисын хэрэгсэл',
        field: 'Талбайн / ээлжийн хэрэгсэл',
        account: 'Бүртгэл (аккаунт)',
        other: 'Бусад',
      },
      body: 'Юу хэрэгтэй, яагаад',
      bodyPlaceholder: 'Жишээ нь: Дэлгэц гэмтсэн тул солих шаардлагатай.',
      bodyRequired: 'Юу хэрэгтэйгээ бичнэ үү.',
      bodyTooLong: 'Хамгийн ихдээ {{max}} тэмдэгт.',
      charCount: '{{count}} / {{max}}',
      wanted: 'Хүссэн зүйл (заавал биш)',
      wantedNone: 'Тодорхой зүйл биш',
      replaces: 'Таны аль зүйлийг солих (заавал биш)',
      replacesNone: 'Солихгүй',
      send: 'Хүсэлт илгээх',
      sending: 'Илгээж байна…',
      close: 'Хаах',
      sentToast: 'Хүсэлт илгээгдлээ',
      cancelledToast: 'Хүсэлт цуцлагдлаа',
      mine: 'Миний хүсэлтүүд',
      noneMine: 'Танд хүсэлт алга.',
      cancelRequest: 'Цуцлах',
      askedOn: '{{date}}-нд хүссэн',
      decidedBy: '{{name}}, {{date}}',
      status: {
        open: 'Нээлттэй',
        resolved: 'Шийдвэрлэсэн',
        rejected: 'Татгалзсан',
        cancelled: 'Цуцалсан',
      },
      view: 'Хүсэлтүүд',
      viewHelp: 'Ажилтнуудын тоног төхөөрөмжийн хүсэлт: нээлттэй нь эхэндээ, хамгийн удаан хүлээсэн нь дээрээ.',
      openCount: '{{count}} нээлттэй хүсэлт',
      filterStatus: 'Төлөв',
      filterKind: 'Төрөл',
      any: 'Бүгд',
      none: 'Тохирох хүсэлт алга.',
      loadFailed: 'Хүсэлтүүдийг ачаалж чадсангүй',
      requester: 'Хүсэгч',
      asked: 'Хүссэн',
      what: 'Хүсэлт',
      wantedCol: 'Хүссэн зүйл',
      replacesCol: 'Солих зүйл',
      statusCol: 'Төлөв',
      actions: 'Үйлдэл',
      resolve: 'Шийдвэрлэх',
      reject: 'Татгалзах',
      answerTitle: 'Хүсэлтэд хариулах',
      answerHint: 'Хариулах нь юу ч олгохгүй: олгох бол бусад хэсэгт бүртгэнэ. Хүсэгч и-мэйл болон апп доторх мэдэгдэл хүлээн авна.',
      note: 'Тэмдэглэл',
      noteOptional: 'Тэмдэглэл (заавал биш)',
      noteRequired: 'Яагаад татгалзаж байгаагаа бичнэ үү.',
      resolvedToast: 'Хүсэлтийг шийдвэрлэлээ',
      rejectedToast: 'Хүсэлтийг татгалзлаа',
    },
  },
  en: {
    equipmentRequest: {
      request: 'Request',
      requestHint: 'Ask for new or replacement equipment',
      title: 'Request equipment',
      kindLabel: 'Kind',
      kind: {
        laptop: 'Laptop',
        office: 'Office item',
        field: 'Field / roster gear',
        account: 'Account',
        other: 'Other',
      },
      body: 'What do you need and why',
      bodyPlaceholder: 'For example: the screen is cracked and needs replacing.',
      bodyRequired: 'Say what you need.',
      bodyTooLong: 'At most {{max}} characters.',
      charCount: '{{count}} / {{max}}',
      wanted: 'Item wanted (optional)',
      wantedNone: 'No particular item',
      replaces: 'Replaces one of your items (optional)',
      replacesNone: 'Nothing',
      send: 'Send request',
      sending: 'Sending…',
      close: 'Close',
      sentToast: 'Request sent',
      cancelledToast: 'Request cancelled',
      mine: 'My requests',
      noneMine: 'You have no requests.',
      cancelRequest: 'Cancel',
      askedOn: 'Asked {{date}}',
      decidedBy: '{{name}}, {{date}}',
      status: {
        open: 'Open',
        resolved: 'Resolved',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
      view: 'Requests',
      viewHelp: "People's equipment requests: open ones first, the longest wait on top.",
      openCount: '{{count}} open requests',
      filterStatus: 'Status',
      filterKind: 'Kind',
      any: 'Any',
      none: 'No requests match.',
      loadFailed: 'Could not load the requests',
      requester: 'Requester',
      asked: 'Asked',
      what: 'Request',
      wantedCol: 'Wanted',
      replacesCol: 'Replaces',
      statusCol: 'Status',
      actions: 'Actions',
      resolve: 'Resolve',
      reject: 'Reject',
      answerTitle: 'Answer the request',
      answerHint: 'Answering issues nothing: record any hand-out in the other views. The requester gets an email and an in-app notice.',
      note: 'Note',
      noteOptional: 'Note (optional)',
      noteRequired: 'Say why it is rejected.',
      resolvedToast: 'Request resolved',
      rejectedToast: 'Request rejected',
    },
  },
  ru: {
    equipmentRequest: {
      request: 'Заявка',
      requestHint: 'Подать заявку на новое оборудование или замену',
      title: 'Заявка на оборудование',
      kindLabel: 'Тип',
      kind: {
        laptop: 'Ноутбук',
        office: 'Офисный предмет',
        field: 'Полевое / вахтовое снаряжение',
        account: 'Учётная запись',
        other: 'Прочее',
      },
      body: 'Что нужно и зачем',
      bodyPlaceholder: 'Например: треснул экран, нужна замена.',
      bodyRequired: 'Укажите, что вам нужно.',
      bodyTooLong: 'Не более {{max}} символов.',
      charCount: '{{count}} / {{max}}',
      wanted: 'Нужный предмет (необязательно)',
      wantedNone: 'Без конкретного предмета',
      replaces: 'Заменяет один из ваших предметов (необязательно)',
      replacesNone: 'Ничего',
      send: 'Отправить заявку',
      sending: 'Отправка…',
      close: 'Закрыть',
      sentToast: 'Заявка отправлена',
      cancelledToast: 'Заявка отменена',
      mine: 'Мои заявки',
      noneMine: 'У вас нет заявок.',
      cancelRequest: 'Отменить заявку',
      askedOn: 'Запрошено {{date}}',
      decidedBy: '{{name}}, {{date}}',
      status: {
        open: 'Открыт',
        resolved: 'Выполнен',
        rejected: 'Отклонён',
        cancelled: 'Отменён',
      },
      view: 'Заявки',
      viewHelp: 'Заявки сотрудников на оборудование: сначала открытые, дольше всех ждущие — сверху.',
      openCount: 'Открытых заявок: {{count}}',
      filterStatus: 'Статус',
      filterKind: 'Тип',
      any: 'Любой',
      none: 'Нет подходящих заявок.',
      loadFailed: 'Не удалось загрузить заявки',
      requester: 'Заявитель',
      asked: 'Дата',
      what: 'Заявка',
      wantedCol: 'Нужно',
      replacesCol: 'Заменяет',
      statusCol: 'Статус',
      actions: 'Действия',
      resolve: 'Выполнить',
      reject: 'Отклонить',
      answerTitle: 'Ответ на заявку',
      answerHint: 'Ответ ничего не выдаёт: выдачу отметьте в других разделах. Заявитель получит письмо и уведомление в приложении.',
      note: 'Примечание',
      noteOptional: 'Примечание (необязательно)',
      noteRequired: 'Укажите причину отказа.',
      resolvedToast: 'Заявка выполнена',
      rejectedToast: 'Заявка отклонена',
    },
  },
}
